import React, { Component as C } from "react"
import PropTypes from "prop-types"
import { omit } from "lodash"

import classnames from "classnames"
import styles from "./index.less"
import jss from "jss"
import withSkin from "@cirrus/legacy/app-common/alt/framework/withSkin.jsx"
import v from "../variables.less"
import { toJss, darken } from "@cirrus/legacy/app-common/alt/framework/skin/skinUtils.es6"
import Icon from "@cirrus/legacy/app-components/icons/icon/index.jsx"
import AlignIcon from "@cirrus/legacy/app-components/icons/alignIcon.jsx"

class ToolbarButton extends C {
  static dynamicStyles = null
  static displayName = "ToolbarButton"

  static propTypes = {
    type: PropTypes.string,
  }

  constructor(props) {
    super(props)

    if (ToolbarButton.dynamicStyles == null) {
      const dynamicStylesConfig = toJss(props.skinObject.toolbarButton || {}, {
        button: {
          fontFamily: "",
          color: v.buttonToolbarColor,
          pm_focus: {
            color: v.buttonToolbarColor,
          },
          pm_hover: {
            color: v.buttonToolbarColor,
          },
          pm_active: {
            color: v.buttonToolbarColor,
          },
          success: {
            color: v.buttonSuccessColor,
          },
          error: {
            color: v.buttonErrorColor,
          },
        },
      })

      ToolbarButton.dynamicStyles = jss.createStyleSheet(dynamicStylesConfig).attach()
    }
  }

  getClass() {
    let { classes } = ToolbarButton.dynamicStyles
    return classnames(
      "rs_preserve",
      "toolbarButtonSkinAdjustment",
      classes.button,
      styles.button,
      {
        [styles.disabled]: this.props.disabled,
        [styles[this.props.buttonType]]: this.props.buttonType != null,
      },
      this.props.className,
    )
  }

  getTypeClass() {
    let { classes } = ToolbarButton.dynamicStyles

    var types = {
      default: styles.default,
      success: classnames(styles.success, classes.success),
      error: classnames(styles.error, classes.error),
    }

    var type = types[this.props.type]

    return type
  }

  render() {
    let iconClass = classnames(styles.icon, this.getTypeClass(), this.props.iconClassName)
    let iconAfterClass = classnames(styles.icon, this.props.iconAfterClassName)

    let icon = null
    if (this.props.icon) {
      icon = this.props.alignIcon ? (
        <AlignIcon
          facadeClassName={styles.alignIcon}
          width={`${this.props.alignIcon.size}px`}
          height={`${this.props.alignIcon.size}px`}
          top={`${this.props.alignIcon.top}px`}
          left={"0px"}>
          <Icon
            style={{ fontSize: `${this.props.alignIcon.size}px` }}
            key={this.props.icon}
            icon={this.props.icon}
            className={iconClass}
          />
        </AlignIcon>
      ) : (
        <Icon key={this.props.icon} icon={this.props.icon} className={iconClass} />
      )
    }

    let iconAfter = this.props.iconAfter ? (
      <Icon key={this.props.iconAfter} icon={this.props.iconAfter} className={iconAfterClass} />
    ) : null

    let children = this.props.children

    let controlType = this.props.controlType || "button"
    let buttonProps = omit(this.props, ["dataQa", "skinObject"]) //TODO: refactor to white list

    let props = {
      onClick: buttonProps.onClick,
      onFocus: buttonProps.onFocus,
      onBlur: buttonProps.onBlur,
      onMouseEnter: buttonProps.onMouseEnter,
      onMouseLeave: buttonProps.onMouseLeave,
      onMouseDown: buttonProps.onMouseDown,
      onMouseUp: buttonProps.onMouseUp,
      className: this.getClass(),
      disabled: buttonProps.disabled,
      tabIndex: buttonProps.tabIndex,
      autoFocus: buttonProps.autoFocus,
      href: controlType === "link" && !this.props.disabled ? buttonProps.href : null,
    }

    if (this.props.setRef) {
      props.ref = this.props.setRef
    }

    if (controlType === "button") {
      return (
        <button {...props} data-qa={this.props.dataQa}
                id={this.props.id}>
          {icon}
          {children}
          {iconAfter}
        </button>
      )
    }

    if (controlType === "link") {
      return (
        <a {...props} data-qa={this.props.dataQa}>
          {icon}
          {children}
          {iconAfter}
        </a>
      )
    }
  }
}

export default withSkin(ToolbarButton)
